import { apiEsign } from "@/api/esign.api.ts";
import { useEffect, useState } from "react";

export function useEsignRequestSourceUrl(requestId: string | null) {
  const [url, setUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(!!requestId);
  const [isError, setIsError] = useState(false);
  const [syncedRequestId, setSyncedRequestId] = useState(requestId);

  if (requestId !== syncedRequestId) {
    setSyncedRequestId(requestId);
    if (requestId) {
      setIsLoading(true);
      setIsError(false);
    } else {
      setUrl(null);
    }
  }

  useEffect(() => {
    if (!requestId) return;

    let isActive = true;
    let objectUrl: string | null = null;

    void (async () => {
      const { data, error, headers } = await apiEsign.getRequestSourceDocument(requestId);
      if (!isActive) return;

      if (error || !data) {
        setIsError(true);
        setIsLoading(false);
        return;
      }

      const contentType = headers?.["content-type"];
      const blobType = typeof contentType === "string" ? contentType : "application/pdf";
      const blob = data instanceof Blob ? data : new Blob([data], { type: blobType });
      objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);
      setIsLoading(false);
    })();

    return () => {
      isActive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [requestId]);

  return { url, isLoading, isError };
}
